module.exports = __webpack_public_path__ + "img/facebookIcon.ac18b83f.svg";